// Minimal markdown renderer for bold, headings, lists — no external deps.
export function MarkdownLite({ text }) {
  if (!text) return null;
  const lines = String(text).split("\n");
  const render = (line) => {
    const parts = line.split(/(\*\*[^*]+\*\*)/g);
    return parts.map((p, i) =>
      p.startsWith("**") && p.endsWith("**") ? (
        <strong key={i} className="font-semibold text-white">{p.slice(2, -2)}</strong>
      ) : (
        <span key={i}>{p}</span>
      )
    );
  };
  return (
    <div className="space-y-1.5 leading-relaxed">
      {lines.map((line, i) => {
        const t = line.trim();
        if (!t) return <div key={i} className="h-1.5" />;
        if (t.startsWith("### ")) return <h4 key={i} className="mt-2 font-heading text-sm font-semibold text-slate-100">{render(t.slice(4))}</h4>;
        if (t.startsWith("## ")) return <h3 key={i} className="mt-2 font-heading text-base font-semibold text-white">{render(t.slice(3))}</h3>;
        if (t.startsWith("# ")) return <h2 key={i} className="mt-2 font-heading text-lg font-bold text-white">{render(t.slice(2))}</h2>;
        if (/^[-*•]\s/.test(t)) return <div key={i} className="flex gap-2 pl-1"><span className="text-blue-400">•</span><span>{render(t.replace(/^[-*•]\s/, ""))}</span></div>;
        if (/^\d+\.\s/.test(t)) return <div key={i} className="pl-1">{render(t)}</div>;
        return <p key={i}>{render(t)}</p>;
      })}
    </div>
  );
}
